import { Component, OnInit } from '@angular/core';
import {RulesService} from '../../rules.service';
import {Constants} from '../../constants';
import {Params, Router} from '@angular/router';
import {PageCanDeactivate} from '../../common/can-deactivate/can-deactivate-page';

@Component({
  selector: 'app-rule-builder',
  templateUrl: './rule-builder.component.html',
  styleUrls: ['./rule-builder.component.scss']
})
export class RuleBuilderComponent extends PageCanDeactivate implements OnInit {
  rows;
  isSubmitted;
  page = 1;
  pageSize = 10;
  constructor(private ruleService: RulesService,
              private router: Router) { super(); }
  ngOnInit() {
    this.buildConditionRows(this.getPredicate());
    this.ruleService.setActionList(this.getActionList());
    this.getThingList();
    if(!this.getPredicate()) {
      this.ruleService.resetSavedThings();
    }
  }

  get hasChanges(): boolean{
      return this.ruleService.isValid(Constants.STEP_ONE);
  }
  private buildConditionRows(predicate) {
     this.ruleService.setConditionRows(predicate);
     this.rows = this.ruleService.rows;
  }
  private getPredicate() {
    const ruleModel = this.ruleService.getRuleModel();
    const predicate = ruleModel ? ruleModel.predicate : ruleModel;
    return predicate;
  }
  private getActionList(): Array<any> {
    const ruleModel = this.ruleService.getRuleModel();
    const actions = ruleModel ? ruleModel.actions : [];
    return actions;
  }
  get isInValid() {
    return this.isSubmitted && !this.ruleService.isValid(Constants.STEP_ONE);
  }
  get ruleId() {
    const ruleModel = this.ruleService.getRuleModel();
    return ruleModel && ruleModel.id ? ruleModel.id : 'new';
  }
  goToNext() {
     this.isSubmitted = true;
     if (this.ruleService.isValid(Constants.STEP_ONE)) {
       this.ruleService.toRuleModel();
       this.router.navigate([`rules/${this.ruleId}/step-3`]);
     };
  }
  cancel() {
    this.router.navigate([`rules/list`]);
  }
  private getThingList() {
    this.ruleService.getThingList(this.page, this.pageSize);
  }

}



// WEBPACK FOOTER //
// ./src/app/rules/new-rule/rule-builder/rule-builder.component.ts